import { render } from "./product-preview.vue?vue&type=template&id=b1362cbc&ts=true"
import script from "./product-preview.vue?vue&type=script&lang=ts"
export * from "./product-preview.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__